import { Button, styled } from '@mui/material';

export const Wrapper = styled('div')`
  margin-top: 24px;
  display: flex;
  align-items: flex-start;

  @media (max-width: 1023px) {
    margin-top: 42px;
  }
`;

export const ButtonW = styled(Button)`
  text-transform: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-left: 328px;
  @media (max-width: 1023px) {
    display: none;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 671px;
  margin: 0 auto;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;
